// Hero images (also managed here for admin panel)
export const HERO_IMAGES = [
  'https://images.unsplash.com/photo-1520340356584-f9917d1eea6f?w=1920&q=80',
  'https://images.unsplash.com/photo-1601362840469-51e4d8d58785?w=1920&q=80',
  'https://images.unsplash.com/photo-1502877338535-766e1452684a?w=1920&q=80',
  'https://images.unsplash.com/photo-1494976388531-d1058494ceb8?w=1920&q=80',
];
